import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState = {
    isShowBannerInfoGoogleAPI: true,
    isShowBannerValidGoogleAPI: true,
    isShowBannerWarningGoogleAPI: false,
    isShowBannerInfoGoogleAPIDeliveryRestriction: true,
    isShowBannerValidGoogleAPIDeliveryRestriction:  true,
    isShowBannerWarningGoogleAPIDeliveryRestriction: false,
};

const ggApiBannerSlice = createSlice({
  name: 'ggApiBanner',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    handleVisibleGGApiBanner: (
      state,
      action: PayloadAction<{
        key: keyof typeof initialState;
        value: boolean;
      }>,
    ) => {
      state[action.payload.key] = action.payload.value;
    },
  },
});

export const showBannerGGApiSelector = createSelector((state: RootState) => state.ggApiBanner, (state) => state)

export const { handleVisibleGGApiBanner } = ggApiBannerSlice.actions;

export default ggApiBannerSlice;
